import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { selectUser } from '../../../redux/userSlice'
import { hasUserPermission } from '../../../utils/permissionHelper'

export function useBankLoginResultsPermissions() {
  const user = useSelector(selectUser)
  const navi = useNavigate()
  const activePermissions = user.spoofed_user?.user_permission_options ? user.spoofed_user.user_permission_options : user.data?.user_permission_options

  useEffect(() => {
    if (user.status === 'succeeded' && user.data.user_permission_options) {
      if (!hasUserPermission(activePermissions, 'can_view_bank_login_results')) {
        navi('/403')
      }
    }
  }, [user, navi, activePermissions])

  return {
    hasManagerApprovalReadPermission: hasUserPermission(activePermissions, 'manager_approval_read'),
    hasManagerApprovalUpdatePermission: hasUserPermission(activePermissions, 'manager_approval_update'),
  }
}
